import React from 'react';

import { StyleUtil } from 'ui/util';
import classNames from './EABDButton.module.scss';

export interface ButtonProps
  extends Readonly<{
    onPress: () => void;
    useLargerFontSize?: boolean;
    children?: React.ReactNode;
  }> {}

export const Button = React.memo<ButtonProps>((props) => {
  const { onPress, useLargerFontSize = false, children } = props;

  const ButtonClassNames = React.useMemo(() => {
    const buttonClassNames: string[] = [classNames.button];

    if (useLargerFontSize) {
      buttonClassNames.push(classNames.largerFontSize);
    }

    return StyleUtil.mergeClassNames(buttonClassNames);
  }, [useLargerFontSize]);

  return (
    <button onClick={onPress} type={'button'} className={ButtonClassNames}>
      {children}
    </button>
  );
});
